/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useMemo } from 'react'
import { Modal, Tabs, Spin, Input, Radio, message, Button } from 'antd'
import FlexWrapMultiSelectPane from 'core/component/FlexWrapMultiSelectPane'
import ActionPane from '../ActionPane'

import R, { path } from 'ramda'

// const getUnits = path(['resources', 'unit'])
// const getDesks = path(['resources', 'desk'])
const getStations = path(['resources', 'station'])
const getcompanies = path(['resources', 'company'])
const getReportNames = path(['resources', 'report'])
// const getShifts = path(['shifts'])
// const userToDisplay = user =>
//   user.firstName != null || user.lastName != null
//     ? `${user.firstName} ${user.lastName} (${user.userName})`
//     : user.userName
const userToDisplay = user =>
  `${user.firstName || user.userName} ${user.lastName ? user.lastName : ''} (${
    user.userName
  })`

const userToId = user => user.userName
const userAcceptFilter = user => filterText =>
  `${user.firstName} ${user.lastName} ${user.userName}`
    .toLowerCase()
    .includes(filterText.toLowerCase())

const RoleModal = ({
  hide,
  role = {},
  updateTask,
  createTask,
  inserting,
  updating,
  deleting,
  users,
  actions,
  // units,
  stationData,
  companyData,
  reportNameMap,
  // stationUtilityMap,
  // companyUtilityMap,
  // setSpinning,
  // unitGroups,
  setError,
  spinning,
  hasCopyAddFunctinality,
  ...props
}) => {
  // need to pass stationData

  // const processing = inserting || updating || deleting
  const { isNew = false } = role
  const [baseData, setBaseData] = useState({
    shifts: 'COMPANY',
    resources: {},
    ...role,
  })

  const [displayErr, setDisplayErr] = useState()
  // const [shift, setShift] = useState(baseData.shifts && baseData.shifts === 'COMPANY')
  const setShift = shifts =>
    setBaseData({
      ...baseData,
      users: [],
      resources: {
        company: baseData.resources.company || [],
        station: baseData.resources.station || [],
        unitGroup: [],
        unit: [],
      },
      shifts,
    })

  const onBaseDataChange = e => {
    if (e.target.id === 'displayName') {
      setBaseData({
        ...baseData,
        [e.target.id]: e.target.value,
        id: isNew
          ? (e.target.value || '').toLowerCase()
          : // .replace(/\W+/g, '-')
            baseData.id,
      })
    } else {
      setBaseData({ ...baseData, [e.target.id]: e.target.value })
    }
  }

  const setSelectedUsers = setter =>
    setBaseData(r => ({ ...r, users: setter(r.users || []) }))
  const selectedUsers = baseData.users || []

  const setSelectedActions = setter =>
    setBaseData(r => ({ ...r, actions: setter(r.actions || []) }))
  const selectedActions = baseData.actions || []

  const setSelectedStations = setter => {
    setBaseData(r => ({
      ...r,
      resources: { ...r.resources, station: setter(getStations(r) || []) },
    }))
  }

  const setSelectedcompanies = setter =>
    setBaseData(r => ({
      ...r,
      resources: { ...r.resources, company: setter(getcompanies(r) || []) },
    }))

  const setSelectedReports = setter =>
    setBaseData(r => ({
      ...r,
      resources: { ...r.resources, report: setter(getReportNames(r) || []) },
    }))

  // const selectedUnits = getUnits(baseData) || []
  const selectedStations = getStations(baseData) || []
  const selectedcompanies = getcompanies(baseData) || []
  const selectedReports = getReportNames(baseData) || []

  const onOk = () => {
    const newShift = baseData.shifts
    if (
      baseData.id === undefined ||
      baseData.id == null ||
      baseData.id.length === 0
    ) {
      // message.error('Please, Provide Role Name')
      setDisplayErr('Please,Provide Role Name')
      return
    }

    if (isNew) {
      const sameDisplayName = props.list.find(
        s => s.displayName === baseData.displayName
      )
      if (sameDisplayName) {
        message.error('Role Name already used.Please provide another name.')
        return
      }
    }
    // updateTask({ ...baseData, shifts: newShift }).fork(e => setError(e, z => hide(null)), hide)
    updateTask({ ...baseData, shifts: newShift, isNew })
  }

  const [handValue, setHandString] = useState('')
  const [notFound, setNotFound] = useState([])

  const companyNameMap = useMemo(
    _ =>
      R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        companyData.map(d => ({ [d.companyName.toLowerCase()]: d.companyId }))
      ),
    [companyData]
  )
  const stationNameMap = useMemo(
    _ =>
      R.reduce(
        (a, b) => ({ ...a, ...b }),
        {},
        stationData.map(d => ({ [d.stationName.toLowerCase()]: d.station }))
      ),
    [stationData]
  )
  const onInputAdd = typeRole => {
    const valList = handValue.split('\n')

    const invertMap = typeRole === 'com' ? companyNameMap : stationNameMap
    let dataList = valList.map(d => invertMap[d.toLowerCase()])
    const notF = valList.filter(d => !invertMap[d.toLowerCase()])
    setNotFound(notF)
    dataList = dataList.filter(f => !!f)
    if (typeRole === 'com') {
      setSelectedcompanies(_ => [...selectedcompanies, ...dataList])
    } else setSelectedStations(_ => [...selectedStations, ...dataList])
  }

  const onClearAdd = typeRole => {
    setNotFound([])
    setHandString('')
  }

  return (
    <Modal
      title={isNew ? `Create New Role` : `Update ${role.displayName}`}
      width="90%"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={hide}
      // zIndex={1020}
      centered
      bodyStyle={{ minHeight: '50vh' }}
      maskClosable={false}
      spinning={spinning}
      okButtonProps={{ loading: spinning }}
      cancelButtonProps={{ loading: spinning }}
    >
      <Spin spinning={spinning}>
        <div css={{ borderBottom: 'solid 1px #eee', paddingBottom: '32px' }}>
          <div
            css={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <label css={{ marginRight: '5px' }} htmlFor="title">
              Display Name:
            </label>
            <Input
              placeholder="Role Name"
              autoFocus={isNew}
              title="DisplayName"
              css={{ flex: '1 0 100px', marginRight: '16px' }}
              id="displayName"
              onChange={onBaseDataChange}
              value={baseData.displayName}
              disabled={!isNew}
            />
            <label css={{ marginRight: '5px' }} htmlFor="role-type">
              Role Base associated:
            </label>
            <Radio.Group
              buttonStyle="solid"
              value={baseData.shifts}
              onChange={e => setShift(e.target.value)}
            >
              <Radio.Button value="COMPANY">Company</Radio.Button>
              <Radio.Button value="STATION">Station</Radio.Button>
            </Radio.Group>
          </div>
          {displayErr && (
            <div css={{ color: 'red', marginRight: '5px' }}>{displayErr}</div>
          )}
        </div>

        <Tabs defaultActiveKey="actions" onChange={onClearAdd}>
          <Tabs.TabPane
            key="actions"
            tab={`Actions (${selectedActions.length})`}
          >
            <ActionPane
              actions={actions}
              selectedIds={selectedActions}
              setSelectedIds={setSelectedActions}
              contentHeightOffset={450}
            />
          </Tabs.TabPane>

          {/* <Tabs.TabPane key="members" tab={`Members (${selectedUsers.length})`}>
            <FlexWrapMultiSelectPane
              data={users}
              selectedIds={selectedUsers}
              setSelectedIds={setSelectedUsers}
              toDisplay={userToDisplay}
              toId={userToId}
              acceptFilter={userAcceptFilter}
              contentHeightOffset={450}
            />
          </Tabs.TabPane> */}

          {baseData.shifts === 'COMPANY' && (
            <Tabs.TabPane
              key="companies"
              tab={`Companies (${selectedcompanies.length})`}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    '3fr ' + (hasCopyAddFunctinality ? ' 1fr' : ''),
                }}
              >
                <div>
                  <FlexWrapMultiSelectPane
                    data={companyData}
                    selectedIds={selectedcompanies}
                    setSelectedIds={setSelectedcompanies}
                    toDisplay={p => `${p.companyName}`}
                    toId={p => p.companyId}
                    contentHeightOffset={450}
                    acceptFilter={comp => text =>
                      `${comp.companyId} ${comp.companyName}`
                        .toLowerCase()
                        .includes(text.toLowerCase())}
                  />
                </div>
                {hasCopyAddFunctinality && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateRows: '3fr 20px 3fr',
                      gridGap: '5px',
                      border: '1px solid #eee',
                      marginLeft: '5px',
                    }}
                  >
                    <Input.TextArea
                      placeholder="Paste Name here"
                      style={{
                        gridColumnEnd: 'span 1',
                        margin: '10px',
                        // minWidth: '200px',
                        width: 'auto',
                      }}
                      value={handValue}
                      onChange={e => setHandString(e.target.value)}
                      rows={5}
                    />

                    <div style={{ display: 'flex', height: 'fit-content' }}>
                      <Button
                        style={{ width: 'max-content', marginLeft: '10px' }}
                        onClick={_ => onInputAdd('com')}
                      >
                        Add
                      </Button>
                      <Button
                        style={{ width: 'max-content', marginLeft: '10px' }}
                        onClick={_ => onClearAdd('com')}
                      >
                        Clear
                      </Button>

                      {notFound.length > 0 && (
                        <div
                          style={{
                            minWidth: '200px',
                            marginLeft: '30px',
                            display: 'grid',
                            alignContent: 'center',
                          }}
                        >
                          Below Names not found
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: 'grid',
                        alignContent: 'top',
                        marginTop: '5px',
                        minHeight: '10px',
                      }}
                    >
                      <div
                        style={{
                          overflow: 'auto',
                          width: 'auto',
                          display: 'grid',
                          maxHeight: '200px',
                          alignContent: 'baseline',
                          margin: '10px',
                          padding: '10px',
                          border: '1px solid #eee',
                        }}
                      >
                        {notFound.map(c => (
                          <div key={c} style={{ color: 'red' }}>
                            {c}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Tabs.TabPane>
          )}
          {baseData.shifts === 'STATION' && (
            <Tabs.TabPane
              key="stations"
              tab={`Stations (${selectedStations.length})`}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    'auto' + (hasCopyAddFunctinality ? ' 400px' : ''),
                }}
              >
                <div>
                  <FlexWrapMultiSelectPane
                    data={stationData}
                    selectedIds={selectedStations}
                    setSelectedIds={setSelectedStations}
                    toDisplay={p => `${p.stationName}`}
                    toId={p => p.station}
                    contentHeightOffset={450}
                    acceptFilter={station => text =>
                      `${station.station} ${station.stationName}`
                        .toLowerCase()
                        .includes(text.toLowerCase())}
                  />
                </div>
                {hasCopyAddFunctinality && (
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateRows: '3fr 20px 3fr',
                      gridGap: '5px',
                      border: '1px solid #eee',
                      marginLeft: '5px',
                    }}
                  >
                    <Input.TextArea
                      placeholder="Paste Name here"
                      style={{
                        gridColumnEnd: 'span 1',
                        margin: '10px',
                        // minWidth: '200px',
                        width: 'auto',
                      }}
                      value={handValue}
                      onChange={e => setHandString(e.target.value)}
                      rows={5}
                    />

                    <div style={{ display: 'flex', height: 'fit-content' }}>
                      <Button
                        style={{ width: 'max-content', marginLeft: '10px' }}
                        onClick={_ => onInputAdd('sta')}
                      >
                        Add
                      </Button>
                      <Button
                        style={{ width: 'max-content', marginLeft: '10px' }}
                        onClick={_ => onClearAdd('com')}
                      >
                        Clear
                      </Button>
                      {notFound.length > 0 && (
                        <div
                          style={{
                            minWidth: '200px',
                            marginLeft: '30px',
                            display: 'grid',
                            alignContent: 'center',
                          }}
                        >
                          Below Names not found
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        overflow: 'auto',
                        width: 'auto',
                        display: 'grid',
                        maxHeight: '200px',
                        alignContent: 'baseline',
                        margin: '10px',
                        padding: '10px',
                        border: '1px solid #eee',
                      }}
                    >
                      {notFound.map(c => (
                        <div key={c} style={{ color: 'red' }}>
                          {c}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Tabs.TabPane>
          )}

          {/* <Tabs.TabPane key="unitGroup" tab={`Unit Group (${selectedUnitGroup.length})`}>
          <FlexWrapMultiSelectPane
            data={unitGroups}
            selectedIds={selectedUnitGroup}
            setSelectedIds={setSelectedUnitGroups}
            toDisplay={p => `${p.unitGroup}`}
            toId={p => p.unitGroup}
            contentHeightOffset={450}
            acceptFilter={ug => text =>
              `${ug.unitGroup}`.toLowerCase().includes(text.toLowerCase())}
          />
        </Tabs.TabPane>

        <Tabs.TabPane key="units" tab="Units">
          <FlexWrapMultiSelectPane
            data={avaliableUnits}
            selectedIds={selectedUnits}
            setSelectedIds={setSelectedUnits}
            renderFilters={
              <div>
                <Dropdown overlay={unitTypeCodeMenus} css={{ marginLeft: '10px' }}>
                  <Button>
                    Toggle Unit Type Code <Icon type="down" />
                  </Button>
                </Dropdown>
              </div>
            }
            toDisplay={u => `${u.unitName}`}
            toId={u => u.unitId}
            contentHeightOffset={450}
            acceptFilter={unit => text =>
              `${unit.unitId} ${unit.unitName} ${unit.iso} ${unit.station}`
                .toLowerCase()
                .includes(text.toLowerCase())}
          />
        </Tabs.TabPane> */}

          <Tabs.TabPane
            key="reports"
            tab={`Reports (${selectedReports.length})`}
          >
            <FlexWrapMultiSelectPane
              data={Object.keys(reportNameMap).map(r => ({
                id: r,
                display: reportNameMap[r],
              }))}
              selectedIds={selectedReports}
              setSelectedIds={setSelectedReports}
              toDisplay={u => u.display}
              toId={u => u.id}
              contentHeightOffset={450}
              acceptFilter={unit => text =>
                `${unit.id} ${unit.display}`
                  .toLowerCase()
                  .includes(text.toLowerCase())}
            />
          </Tabs.TabPane>

          {/*
          <Tabs.TabPane key="api" tab="Api Keys">
            <div>Not yet implemented</div>
          </Tabs.TabPane>
          */}
        </Tabs>
      </Spin>
    </Modal>
  )
}

export default RoleModal
